import gettext from '@sdk/lang/gettext';
import { SmartTooltip } from '@sdk/common/tooltip/SmartTooltip';

import HistoryIconSvg from '@web/assets/svg/Icons/32/history-gray.svg';
import BackSvg from '@web/assets/svg/UI/back.svg';
import { ClickableHeaderButton } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalHeader/timesheetViewModalHeader.styles';

type Props = {
  onClick: () => void;
  isHistoryView: boolean;
};

const HistoryHeaderButton = ({ onClick, isHistoryView }: Props) => {
  const content = isHistoryView ? gettext('Back') : gettext('Show history');
  const Icon = isHistoryView ? BackSvg : HistoryIconSvg;

  // The changing key property ensures that the tooltip element won't be reused
  // by React and linger in the UI after clicking the button
  // https://github.com/getsling/sling-issues/issues/6857

  return (
    <SmartTooltip content={content} key={content}>
      <ClickableHeaderButton onClick={onClick}>
        <Icon />
      </ClickableHeaderButton>
    </SmartTooltip>
  );
};

export default HistoryHeaderButton;
